// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2LHIy","alert":"SettungsInbox_alert__20mRj"};